import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { type HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'

export class GetCommunityChannelsQuery extends GetNetworkQuery {
  constructor(
    private readonly fromDate: string,
    private readonly toDate: string,
    private readonly fromPrevious: string,
    private readonly toPrevious: string,
    private readonly sortBy: string,
    private readonly sortOrder: string,
    private readonly organization: string
  ) {
    super(ApiEndpoint.EngagementCommunityChannels)
  }

  public get queryParameters(): HttpParameters {
    return {
      from_date: this.fromDate,
      to_date: this.toDate,
      from_previous: this.fromPrevious,
      to_previous: this.toPrevious,
      sort_by: this.sortBy,
      sort_order: this.sortOrder,
      organization: this.organization
    }
  }
}
